import {
  cycleResult,
  cycleDate,
  cycleDay,
  entryToISO,
  cycleCreatedAt,
} from "../../creacionCiclo/model/cycleModel";

// Convierte únicamente literales de datos; nunca ejecuta el contenido de una respuesta.
export function parseAccesparkResponse(value) {
  if (value && typeof value === "object") return value;
  if (typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    /* Algunos registros históricos usan comillas simples. */
  }
  let json = "";
  for (let i = 0; i < value.length; ) {
    const char = value[i];
    if (char === "'" || char === '"') {
      const quote = char;
      let text = "";
      let closed = false;
      i++;
      while (i < value.length) {
        let next = value[i++];
        if (next === quote) {
          closed = true;
          break;
        }
        if (next === "\\") {
          next = value[i++];
          const escapes = {
            n: "\n",
            r: "\r",
            t: "\t",
            b: "\b",
            f: "\f",
            "\\": "\\",
            "'": "'",
            '"': '"',
            "/": "/",
          };
          if (next === "u") {
            const hex = value.slice(i, i + 4);
            if (!/^[0-9a-f]{4}$/i.test(hex)) return null;
            text += String.fromCharCode(parseInt(hex, 16));
            i += 4;
          } else if (Object.prototype.hasOwnProperty.call(escapes, next)) text += escapes[next];
          else return null;
        } else text += next;
      }
      if (!closed) return null;
      json += JSON.stringify(text);
    } else {
      const literal = /^(None|True|False)\b/.exec(value.slice(i));
      if (literal) {
        json += { None: "null", True: "true", False: "false" }[literal[1]];
        i += literal[0].length;
      } else {
        json += char;
        i++;
      }
    }
  }
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}
export function accesparkResult(value, cycleType) {
  const parsed = parseAccesparkResponse(value);
  const result = cycleResult(parsed);
  const message = result.message
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (result.severity === "success" && isOpeningCycle(cycleType)) result.label = "Apertura exitosa";
  if (result.severity === "success" && [2, 5].includes(Number(cycleType)))
    result.label = "Completado";
  if (!parsed && value)
    return { code: null, severity: "error", label: "Respuesta no válida", message: String(value) };
  const labels = [
    ["solicitud pendiente", "Solicitud pendiente"],
    [
      "vehiculo sin ciclo",
      [2, 5].includes(Number(cycleType)) ? "Sin ciclo activo" : "Vehículo sin ciclo",
    ],
    [
      "vehiculo con ciclo",
      [2, 5].includes(Number(cycleType)) ? "Ciclo activo" : "Vehículo con ciclo activo",
    ],
    ["terminal not existing", "Terminal no encontrada"],
    ["not found", "No encontrado"],
    ["times are not consistent", "Horas inconsistentes"],
    ["different state rather than active", "Tag inactivo"],
    ["ingreso no permitido", "Ingreso no permitido"],
    ["ingreso y salida no permitida", "Ingreso y salida no permitidos"],
  ];
  if (result.severity !== "success")
    result.label = labels.find(([match]) => message.includes(match))?.[1] || result.label;
  return result;
}
export function accesparkDate(value) {
  if (typeof value !== "string") return value;
  return value.replace(
    /^(\d{4}-\d\d-\d\d) (\d\d:\d\d:\d\d(?:\.\d+)?) ([+-]\d\d)(\d\d)$/,
    "$1T$2$3:$4"
  );
}
export const displayAccesparkDate = (value) => cycleDate(accesparkDate(value));
// Compatibilidad de get-cycles: los createdAt en UTC llegan cinco horas adelantados
// respecto al registro esperado en Colombia. La corrección es solo de presentación;
// no se aplica a metadata.exit, capturetime, fechas del formulario ni al reloj local.
export function displayAccesparkCreatedAt(value) {
  return cycleCreatedAt(accesparkDate(value));
}

export const accesparkDay = (value) => cycleDay(accesparkDate(value));
export function accesparkEntry(date, time) {
  return entryToISO(date, time).replace("T", " ").replace("-05:00", " -0500");
}
export function mapAccesparkCycles(rows) {
  return rows
    .map((row) => ({
      ...row,
      eventAt: isOpeningCycle(row.cycle_type)
        ? row.metadata?.entry ?? row.metadata?.exit ?? row.payload?.capturetime ?? null
        : row.metadata?.exit ?? row.payload?.capturetime ?? null,
      result: accesparkResult(row.response, row.cycle_type),
    }))
    .sort((a, b) => Number(b.id) - Number(a.id));
}
export function filterAccesparkCycles(rows, filters) {
  const query = filters.search.trim().toLowerCase();
  return rows.filter((row) => {
    const day = accesparkDay(row.eventAt);
    return (
      (!filters.commerce || row.metadata?.commerce === filters.commerce) &&
      (!filters.start || Boolean(day && day >= filters.start)) &&
      (!filters.end || Boolean(day && day <= filters.end)) &&
      (!filters.result || row.result.severity === filters.result) &&
      (!query ||
        [
          row.id,
          row.metadata?.plate,
          row.metadata?.commerce,
          row.metadata?.idterminal,
          row.metadata?.userId ?? row.user_id,
          row.ip,
          row.result.code,
          row.result.label,
          row.result.message,
        ].some((value) =>
          String(value ?? "")
            .toLowerCase()
            .includes(query)
        ))
    );
  });
}

export function terminalDirection(type) {
  if (typeof type !== "number" && typeof type !== "string") return null;
  const value = Number(type);
  if (!Number.isSafeInteger(value) || value <= 0) return null;
  return value % 2 === 0 ? "Salida" : "Entrada";
}

// Los tipos del historial no son los tipos de terminal: Ezytec usa 4 para apertura y 5 para cierre.
export const isOpeningCycle = (type) => [3, 4].includes(Number(type));
